<template>
  <v-card color="primary" dark class="rounded-0" style="position: sticky; bottom:0">
    <v-row no-gutters align="center" class="pr-3">
      <v-col cols="auto" class="hovercol2 d-flex align-self-stretch align-center justify-center" style="width: 48px;"
        @click="$emit('clear')">
        <v-btn icon small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto" class="px-3" style="font-size: 14px; line-height: 1;">
        {{ $t('servicesystem.common_objects.commonterms.selected_items') }}
      </v-col>

      <v-spacer></v-spacer>
      <v-col cols="auto" class="py-2">
        <div class="d-flex">
          <slot name="select-actions" :allSelected="allSelected" :excluded="excluded" :filter="filter"
            :selectLoading="selectLoading" :selectMethod="callSelect">
            <AltOptionButton
              :mainAction="{ text: selectText || $t('servicesystem.common_objects.commonterms.use'), onClick: selectMethod }"
              :alternateActions="alternateSelectActions" :loading="selectLoading" :color="'primary darken-1'">
            </AltOptionButton>
          </slot>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>


<script>
import AltOptionButton from "@/views/pim/articles/AltOptionButton.vue";

export default {
  name: "MultiselectActionBar",
  props: {
    selectionFilter: Object,
    allSelected: Boolean,
    selected: Object,
    excluded: Object,
    selectText: String,
    filter: Object,
    selectMethod: {
      required: true,
      type: Function,
    },
    alternateSelectActions: Array,
  },
  components: {
    AltOptionButton,
  },
  mixins: [],

  data() {
    return {
      selectLoading: false,
    };
  },

  methods: {
    async callSelect() {
      this.selectLoading = true;
      await this.selectMethod(this.SelectionFilterDto)
        .finally(() => {
          this.selectLoading = false;
        })
    }
  },

  computed: {
    SelectionFilterDto() {
      return { ...this.selectionFilter, InitialListFilter: this.filter };
    },
  },

  watch: {},
};
</script>


<style scoped></style>